import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProductCategoryListPageBody } from "../components/ProductCategoryListPageBody";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
export const Template = (
    props: templates.ProductCategoryListPageTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <ProductCategoryListPageBody {...props} />
        </PageSkeleton>
    );
};
